import { Button } from "reactstrap";
import { useState } from "react";
import { Modal } from "rsuite";

import FileExplorerSidebar from "./Components/FileExplorerSidebar";
import { FileInterface } from "../../types/RecordInterfaces";
import { FileType } from "../../components/Inputs/UppyFile";
import useToggle from "../../hooks/useToggle";
import Library from "../library/Library";

interface FileExplorerProps {
  open: boolean;
  multiFiles: boolean;
  onClose: () => void;
  onAddFiles: (files: FileInterface[]) => void;
  fileType: FileType;
  fileTypes?: string[];
  isPrivate?: boolean;
  filesToFilter?: FileInterface[];
}

function FileExplorer({
  open,
  onClose,
  onAddFiles,
  multiFiles,
  fileType,
  fileTypes,
  isPrivate,
  filesToFilter = [],
}: FileExplorerProps) {
  const [files, setFiles] = useState<FileInterface[]>([]);
  const [openSidebar, setSidebarToggle] = useToggle(true);

  return (
    <Modal
      size={"lg"}
      open={open}
      backdrop="static"
      onClose={(e) => {
        e.stopPropagation();
        onClose();
      }}
    >
      <Modal.Header>
        <Modal.Title className="tw:px-6 tw:pt-3 h2 tw:mb-0 tw:pb-0">
          <i className="mdi mdi-folder-table tw:text-primary tw:text-xl tw:mr-2" />
          Growth Drive
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="tw:pl-0 tw:md:pl-6 tw:mt-0 tw:h-full tw:w-full">
        <div className="tw:flex tw:pt-5">
          <div className="tw:h-[calc(100vh_-_320px)] tw:hidden tw:md:flex">
            <FileExplorerSidebar
              open={openSidebar}
              setOpen={setSidebarToggle}
            />
          </div>
          <div className="tw:flex tw:w-full tw:h-[calc(100vh_-_320px)]">
            <Library
              type="Growth Drive Explorer"
              withToolbar={true}
              withHeader={false}
              onAddFiles={setFiles}
              multiFiles={multiFiles}
              fileType={fileType}
              fileTypes={fileTypes}
              isPrivate={isPrivate}
              filesToFilter={filesToFilter}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="tw:pb-5 tw:pr-5 tw:pt-5">
        <Button
          disabled={!files?.length}
          color="primary"
          onClick={(e) => {
            e.stopPropagation();
            onAddFiles(files);
            onClose();
          }}
        >
          Add
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default FileExplorer;
